// extracted by mini-css-extract-plugin
export default {"link":"DownloadDocumentLink_link__WIR1e"};